import { BaseImageLoader } from "../Base/BaseImageLoader";

export class ScormImageLoader extends BaseImageLoader {
}